import React, {FC} from 'react';
import {Divider, Grid, Theme, Typography, useMediaQuery} from "@mui/material";
import EditCompanyProfile from "./EditCompanyProfile/EditCompanyProfile";
import AdminInfo from "./AdminInfo";
import {hasAdminAccess} from "../../util/AccountUtils";
import {Account} from "../../types/Account";
import {styled} from "@mui/material/styles";

const CompanyProfileDivider = styled(Divider)(({theme}) => ({
  '&&': { // make sure it overrides ss-divider for compatability
    // horizontal divider for mobile
    margin: '2.14rem 0',
    width: '100%',
    height: 'auto !important',
    // vertical divider for desktop
    [theme.breakpoints.up('md')]: {
      margin: '0 2.14rem',
      width: '0.07rem'
    },
  }
}));

interface CompanyProfile {
  account: Account,
  handleAccountUpdated: (account: Account) => void,
}

const CompanyProfile: FC<CompanyProfile> = ({ account, handleAccountUpdated }) => {
  const isMd = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  return (
    <Grid container component={'article'}>
      <Grid item xs={12} md={5}>
        <Typography variant={'h5'} component={'h1'} color={'textPrimary'}>Company Details</Typography>
        {hasAdminAccess(account) &&
          <AdminInfo
            account={account}
            handleAccountUpdated={handleAccountUpdated}
          />
        }
      </Grid>
      <CompanyProfileDivider orientation={isMd ? 'vertical' : 'horizontal'} flexItem={isMd} className={`ss-divider`} />
      {
        account && <Grid item xs={12} md>
          <EditCompanyProfile
            account={account}
            handleAccountUpdated={handleAccountUpdated}
          />
        </Grid>
      }
    </Grid>
  );
};

export default CompanyProfile;
